export default "__VITE_ASSET__e3f22c22__$_?component__"